export default __webpack_public_path__ + "static/media/ic_documents.92193dfa.svg";